export {CanSaveTranslation} from './CanSaveTranslation'